module.exports = __webpack_public_path__ + "img/shenfenzbei.9218562d.png";